export const PRODUCT_TITLE = "TrialTrackerNx";
export const TRIAL_TRACKER_APP_ID = "6104ba7d-9b53-4430-acbd-4300155bcef6";
